import React, { useContext, useState, useEffect, useRef } from 'react';
import Header from './header';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';

import {
  Navigate,
  Link,
  NavLink,
  useNavigate,
  useParams
} from "react-router-dom";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';
import { AppContext } from '../context';
import { holdUser } from "../features/userdataSlice";
// modal code start

import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';

import IconButton from '@mui/material/IconButton';
import CloseIcon from "@mui/icons-material/Close";

import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import LockIcon from '@mui/icons-material/Lock';
import MailIcon from '@mui/icons-material/Mail';
import secureLocalStorage from "react-secure-storage";

// modal code end
// reset psd code modal end
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}
function Password() {
  const { storage } = useContext(AppContext);

  const [showOrder, setShowOrder] = useState(false);
  const [userData, setuserData] = useState('');
  const dispatch = useDispatch();
  const [user, setUser] = useState({ parent_name: '', parent_email: '', create_pass: '', confirm_pass: '' });
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [loader, setLoader] = useState(false);
  const [password, setPassword] = useState(true);

  const { dispatchStorageEvent } = useContext(AppContext);
  const [erroruserid, setErrorUserid] = useState(false);
  const [errorpassword, setErrorPassword] = useState(false);
  const [errorcontact, setErrorcontact] = useState(false);
  const [errorcreatepassword, setErrorCreatePassword] = useState(false);
  const [errorconfirmpassword, setErrorConfirmPassword] = useState(false);
  const [loginval, setloginval] = useState(0);
  const [loading, setLoading] = useState(false);
  const Axios = axios.create({
    baseURL: storage[0].backEndUrl
    // baseURL: process.env.REACT_APP_ENV_URL
  });
  const timersRef = useRef([]); // Ref to store timers for each character

  let navigate = useNavigate();
  const [forgotmail, setForgotmail] = useState('');
  const [loginvalnew, setloginvalnew] = useState(0);
  const [successMsgforgot, setSuccessMsgforgot] = useState('');
  const [errorMsgforgot, setErrorMsgforgot] = useState('');
  const [loaderforgot, setLoaderforgot] = useState(false);
  const [openForgot, setOpenForgot] = React.useState(false);
  const [submitErr, setSubmitErr] = useState('');
  const [submitSuccess, setSubmitSuccess] = useState('');
  const [submitting, setSubmitting] = React.useState(false);
  const handleOpenForgot = () => {
    setForgotmail('');
    setSuccessMsgforgot('');
    setErrorMsgforgot('');
    setOpenForgot(true);

  }
  const handleCloseForgot = () => {

    setOpenForgot(false);
  }
  const changeUserDataFor = (e) => {
    setForgotmail(e.target.value);
  }


  const handleKeypressfor = e => {

    //it triggers by pressing the enter key
    if (e.which === 13) {
      e.preventDefault();
      handleSubmitfor();

    }
  };


  const handleSubmitfor = (event) => {

    setSuccessMsgforgot('');
    setErrorMsgforgot('');
  // alert(forgotmail);
    if (forgotmail == '' || forgotmail == null  ) { setErrorMsgforgot('Please Enter Email'); return false; }

    setLoaderforgot(true);

    Axios.post(`/forgot_passowrd`, { id: userData.id, email: forgotmail })
      .then(res => {
        console.log(res.data);

        if (res.data.status == true) {
          console.log(res.data.data);
          setForgotmail('');
          setSuccessMsgforgot(res.data.data);

          setLoaderforgot(false);



          setTimeout(function () {
            setSuccessMsgforgot('');
            setOpenForgot(false);

          }, 3000);



        }
        else {

          setErrorMsgforgot(res.data.data);
          setLoaderforgot(false);
        }
      });
  }
  const [visible, setVisible] = useState(false);
  const [openLog, setOpenLog] = React.useState(false);
  const [passwordparent, setPasswordparent] = useState(true);
  // password section code start
  const [openEye, setOpenEye] = React.useState(false);
  const handleClickOpenEye = () => {
    setPasswordparent(false);
    setOpenEye(true);

  }
  const handleClickCloseEye = () => {
    setPasswordparent(true);
    setOpenEye(false);

  }
  const [displayPassword, setDisplayPassword] = useState('');
  const [openLogcon, setOpenLogcon] = React.useState(false);
  const [passwordparentcon, setPasswordparentcon] = useState(true);
  // password section code start
  const [openEyecon, setOpenEyecon] = React.useState(false);
  const handleClickOpenEyecon = () => {
    setPasswordparentcon(false);
    setOpenEyecon(true);

  }
  const handleClickCloseEyecon = () => {
    setPasswordparentcon(true);
    setOpenEyecon(false);

  }
  const logout = (e) => {
    secureLocalStorage.removeItem("username");
    secureLocalStorage.removeItem("userdata");

    dispatch(holdUser({}));
    navigate(`/`);

  }

  React.useEffect(() => {

    if (document.body.classList.contains('body_bg')) {
      document.body.classList.remove('body');

    }
    document.body.classList.add('body_bg');
    var userid = secureLocalStorage.getItem('username');;

    console.log(JSON.parse(secureLocalStorage.getItem('userdata')));
    if (userid == null) {


      navigate(`/`);

    } else {
      setuserData(JSON.parse(secureLocalStorage.getItem('userdata')));
    }
  }, []);

  React.useEffect(() => {
    return cleanupTimers; // Cleanup on component unmount
  }, []);
  const handleKeypress = (e) => {

    //it triggers by pressing the enter key
    if (e.which === 13) {
      e.preventDefault();
      handleSubmit();

    }
  };
  const changeUserData = (e) => {
    setErrorUserid(false);
    setErrorPassword(false);
    setErrorcontact(false);
    setErrorCreatePassword(false);
    setErrorConfirmPassword(false);
    var user_temp = { ...user };
    let curpassfin = '';
    if (e.target.name == 'parent_name') user_temp.parent_name = e.target.value;
    if (e.target.name == 'parent_email') user_temp.parent_email = e.target.value;

    if (e.target.name == 'create_pass') {

      let lastsr = e.target.value;
      let str = e.target.value;
      if (lastsr.length == 1 && lastsr.slice(-1) != '*') {
        user_temp.create_pass = e.target.value;
        //  alert(user_temp.create_pass);
      } else {

        if (lastsr.slice(-1).includes("*")) {

          // alert(user_temp.create_pass);
          user_temp.create_pass = user_temp.create_pass.substring(0, user_temp.create_pass.length - 1);

        } else {
          //  alert(user_temp.create_pass);
          if (user_temp.create_pass != '') {
            user_temp.create_pass = user_temp.create_pass + lastsr.slice(-1);
          } else {
            user_temp.create_pass = e.target.value;
            //  
          }
        }
        if (e.target.value == '') {
          user_temp.create_pass = '';
        }

      }

      setUser(user_temp);
      let curpass = '';
      for (let i = 0; i < (str.length - 1); i++) {
        curpass = curpass + '*';
      }

      for (let i = 0; i < (str.length); i++) {
        curpassfin = curpassfin + '*';
      }

      setDisplayPassword(curpass + lastsr.slice(-1));
      if (e.target.value != '') {

        const timer = setTimeout(() => {
          setDisplayPassword(prev => prev.slice(0, -1) + "*");
        }, 2000);
        // Store the timer in the ref array
        timersRef.current.push(timer);

      }





    }
    // alert(user_temp.create_pass);
    // //  alert(curpassfin);

    setloginvalnew(1);
  }

  const cleanupTimers = () => {
    timersRef.current.forEach(timer => clearTimeout(timer));
    timersRef.current = [];
  };


  const handleSubmit = (event) => {

    setErrorMsg('');
    setSuccessMsg('');
    setErrorUserid(false);
    setErrorPassword(false);
    setErrorcontact(false);
    setErrorCreatePassword(false);
    setErrorConfirmPassword(false);
    //alert(user.create_pass);
    // if (user.parent_name == '') { setErrorUserid(true); return false; }
    // if (user.parent_email == '') { setErrorPassword(true); return false; }
    //   if (user.parent_contact == '') { setErrorcontact(true); return false; }
    if (user.create_pass == '') { setErrorCreatePassword(true); return false; }
    // if (user.confirm_pass == '') { setErrorConfirmPassword(true); return false; }

    // if (user.confirm_pass != user.create_pass) { setErrorMsg('Create and Confirm Password must be Same'); return false; }
    setLoader(true);
    Axios.post(`/parents_login`, { email: userData.parent_email, password: (user.create_pass), stuid: userData.stuid })
      .then(res => {
        console.log(res.data);

        if (res.data.status == true) {
          console.log(res.data.consentForm);
          storage[0].userdata = res.data.data;
          secureLocalStorage.setItem("userdata", JSON.stringify(res.data.data));
          secureLocalStorage.setItem('username', res.data.data.stuid);
          secureLocalStorage.setItem('userlogin', res.data.data.stuid);
          secureLocalStorage.setItem('consentForm', (res.data.consentForm));
          secureLocalStorage.setItem('allloactions', (res.data.locations));

          dispatchStorageEvent(storage);
          setSuccessMsg('Login Successfully!');
          secureLocalStorage.setItem("studenentformdata", JSON.stringify(res.data.studentdata));
          setLoader(false);
          setloginval(3);







        }
        else {
          setloginval(0);
          setErrorMsg(res.data.data);
          setLoader(false);
        }
      });
  }

  const [openformsLog, setOpenformsLog] = React.useState(false);
  const handleFormsClose = () => setOpenformsLog(false);
  const handleFormsOpen = () => setOpenformsLog(true);;


  const handlereregis = (event) => {
    // handleCloseForgot();
    // setOpenformsLog(true);
    setForgotmail(userData.parent_email);
    setErrorMsgforgot('');
  }

  const handleFormStatus = (item) => {
    setSubmitting(true);
    Axios.post(`/reregister`, {
      studentid: userData.stuid
    })
      .then(res => {
        if (res.data.status) {
          secureLocalStorage.setItem("userdata", JSON.stringify(res.data.data));
          setloginval(4);
        } else {
          setSubmitErr(res.data.data);

        }
        setSubmitting(false);
      })
  }

  if (loginval == 3) {
    return <Navigate to='/instruction' />;
  }
  if (loginval == 4) {
    return <Navigate to='/registration' />;
  }
  return (
    <>
      <Header />

      <div className='regis-main-sec'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <div className='regis-head pass-head'>
                <h2>PASSWORD </h2>
                {/*<p>You only register once</p>*/}
              </div>
            </div>
          </div>

          <div className='regis-form-sec'>
            <div className='row'>
              <div className='col-md-12'>
                <div className='login-sec-page modl-login regis-top login-sec-pageforgot pass-wrd-sec'>




                  <div className={`login-secs regis-email login-secssss ${displayPassword != '' && 'new-pass-ass'}`}>
                    <Box
                      component="form"
                      sx={{
                        '& > :not(style)': { m: 1, width: '100%', margin: '0 auto' },
                      }}
                      noValidate
                      autoComplete="off"
                    >

                      <TextField id="standard-basic" label="Password" variant="outlined"
                        type={'text'}
                        onKeyPress={(e) => { handleKeypress(e); }}


                        name="create_pass"
                        value={passwordparent ? displayPassword : user.create_pass} onChange={changeUserData}

                        error={errorcreatepassword} placeholder=''

                        helperText={` ${errorcreatepassword == true ? 'Please enter Password!' : ''}`} className="required" />
                      <span className='login-icon-regis'><LockIcon /></span>

                      {/* <div className='psd-sec'>
                            <span className="visible-sec" onClick={handleClickOpenEye} style={{display: openEye ? "none" : "block" }}><VisibilityOffIcon /></span>
                            <span className="visible-sec" onClick={handleClickCloseEye} style={{display: openEye ? "block" : "none" }}><VisibilityIcon /></span>
                    </div>*/}
                    </Box>
                    <p className="forgot-psd-sec forgot-new-secsss" onClick={handleOpenForgot}>Forgot Password ?</p>

                  </div>



                  <div className='login-submit pass-subm' style={{ textAlign: 'center' }}>

                    <button className='btn btn-login btn-login-sumt btn-reg-submt' onClick={handleSubmit}>SUBMIT
                      {
                        loader != '' ?
                          <CircularProgress style={{ width: "15px", height: "15px", marginLeft: "5px", color: "#ffffff", position: 'absolute', marginTop: '3px' }} />
                          : ''

                      }</button>
                    {
                      loader != '' ? <div className="success-msg success-new-msg">
                        <p className="success-msg">Please wait while we get you access to the system</p>

                      </div> :
                        <div className="success-msg success-new-msg">
                          <p className="success-msg" style={{ visibility: 'hidden' }} >Please wait while we get you access to the system</p>
                        </div>
                    }

                    {
                      successMsg != '' ? <div className="success-msg">
                        <p className="success-msg">{successMsg}</p>
                      </div> : ''
                    }


                    {
                      errorMsg != '' ? <div className="error-msg" >
                        <p className="error-msg">{errorMsg}</p>
                      </div> : <div className="error-msg" style={{ visibility: 'hidden' }} >
                        <p className="error-msg">Wrong credentials!</p>
                      </div>
                    }

                  </div>

                </div>

              </div>
            </div>
          </div>

        </div>

      </div>



      {/* modal for forgot password start */}
      <BootstrapDialog
        onClose={handleCloseForgot}
        aria-labelledby="customized-dialog-title"
        open={openForgot} className="route-view copy-view logout-view login-modal">
        <BootstrapDialogTitle className="close-routeview" id="customized-dialog-title" onClose={handleCloseForgot}>
          {/* <h2 style={{padding:'5px 0px 0px 0px',color:'#ffffff'}}>Logout</h2> */}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            <div className='copy-sec-modal logout-sec-modal add-club-sec' style={{ paddingTop: '0px' }}>
              {/* <h2 style={{color:'#57585A',paddingTop:'0px'}}>Logout</h2> */}

              <h2>Forgot Password</h2>
              <p className="forgot-psd-secnew " >Use your registered email id to get a password reset link</p>


              <div className='login-mdl-sec'>

                <div className='login-secs modl-login'>
                  <Box
                    component="form"
                    sx={{
                      '& > :not(style)': { m: 1, width: '100%', margin: '0 auto' },
                    }}
                    noValidate
                    autoComplete="off"
                  >

                    <TextField id="standard-basic" label="Email Id" variant="outlined"
                      value={forgotmail} onChange={changeUserDataFor} onKeyPress={handleKeypressfor}
                      name="forem" />
                    <span className='login-icon mod-login-icn'><MailIcon /></span>


                  </Box>
                  <p className="forgot-psd-sec forgot-new-secsss forgot-new-secsss-reregis" onClick={handlereregis}>Show My Email ID</p>

                </div>
                <div className='login-submit mdl-lgn-sbm sub-login-sec'>
                  <button className='btn btn-login btn-login-sumt btn-mdl-smt' onClick={handleSubmitfor}>SUBMIT

                    {
                      loaderforgot != '' ?
                        <CircularProgress style={{ width: "15px", height: "15px", marginLeft: "5px", color: "#ffffff", position: 'absolute', marginTop: '3px' }} />
                        : ''

                    }</button>
                  {/* <button className='btn btn-login btn-login-sumt btn-mdl-smt reregsi-sib  btn-clear' onClick={handleFormStatus}>

                    {
                      submitting ?
                        <>
                          REGISTER AGAIN <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        </>
                        :
                        <>
                          REGISTER AGAIN
                        </>
                    }
                  </button> */}
                  {/* {
                submitting ?
                <div className="success-msgfor success-new-msgfor new-sucs-main ">
                <p className="success-msgfor new-sucss">Please wait while we get you to register again</p>

              </div>
                  : null
              } */}

                  {
                    loaderforgot != '' ? <div className="success-msgfor success-new-msgfor new-sucs-main">
                      <p className="success-msgfor new-sucss">Please wait while we get you access to the system</p>

                    </div> :
                      <div className="success-msgfor success-new-msgfor new-sucs-main">
                        <p className="success-msgfor new-sucss" style={{ visibility: 'hidden' }}  >Password Reset Link sent to your registered email address, remember to check spam box if it isn't there in your inbox</p>
                      </div>
                  }
                  {
                    successMsgforgot != '' ? <div className="success-msgfor success-new-msgfor new-sucs-main">
                      <p className="success-msgfor new-sucss">Password Reset Link sent to your registered email address, remember to check spam box if it isn't there in your inbox</p>

                    </div> : ''
                  }


                  {
                    errorMsgforgot != '' ? <div className="error-msg error-login erron-neww" >
                      <p className="error-msg error-login erron-neww-dd">{errorMsgforgot}</p>
                    </div> : <div className="error-msg error-login erron-neww" style={{ visibility: 'hidden' }} >
                      <p className="error-msg error-login erron-neww-dd">Wrong credentials!</p>
                    </div>
                  }
                </div>

              </div>


            </div>


          </Typography>
        </DialogContent>
      </BootstrapDialog>


      <BootstrapDialog
        onClose={handleFormsClose}
        aria-labelledby="customized-dialog-title"
        open={openformsLog} className="route-view copy-view logout-view login-modal app-modal action-modl">
        <BootstrapDialogTitle className="close-routeview" id="customized-dialog-title" onClose={handleFormsClose}>
          {/* <h2 style={{padding:'5px 0px 0px 0px',color:'#ffffff'}}>Logout</h2> */}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            {/* <div className='copy-sec-modal logout-sec-modal add-club-sec app-club-sec'  style={{display:  rejectLog  ? 'none' : 'block' }}> */}
            <div className={`copy-sec-modal logout-sec-modal add-club-sec app-club-sec `}  >

              <h2>Do you want to re-register?</h2>


              <div className='button-sec-app'>

                <button className="btn btn-login btn-submit bt-forms btn-appr" onClick={() => handleFormStatus()}>

                  {
                    submitting ?
                      <>
                        Yes <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      </>
                      :
                      <>
                        Yes
                      </>
                  }
                </button>
                <button className="btn btn-login btn-submit bt-forms btn-reject" onClick={handleFormsClose}>No </button>



              </div>
              {
                submitSuccess ?
                  <div className="success-msg success-login success-new-msg">
                    <p className="success-msg success-login" >{submitSuccess}</p>
                  </div>
                  : null
              }
              {
                submitErr ?
                  <div className="error-msg error-login" >
                    <p className="error-msg error-login">{submitErr}</p>
                  </div>
                  : null
              }
            </div>







          </Typography>
        </DialogContent>
      </BootstrapDialog>
      {/* modal for forgot password end */}
    </>
  )
}

export default Password;